<app-shared-dialog
  [title]="((canSubmit$ | async) === true ? (((!isUpdate ? 'common.new' : 'common.update') | translate) + ' ') : '') + ('Labels.label' | translate)"
  [options]="{
    size: 'medium',
    confirmText: (!isUpdate ? 'common.create' : 'common.update') | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end',
    customConfirmButton: true
  }"
  (cancel)="closed()">

  <form class="add-tags__form" [formGroup]="form">
    <!-- Name -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.name' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="name"
        [placeholder]="'common.name' | translate"
        [errorMessages]="{ required: ('validation.required' | translate) }">
      </ui-form-field>
    </div>

    <!-- Description -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.description' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="description"
        [placeholder]="'common.description' | translate">
      </ui-form-field>
    </div>

    <!-- Color -->
    <div class="form-field">
      <label class="form-field__label">{{ 'Labels.label_color' | translate }}</label>
      <div class="add-tags__color">
        <label class="add-tags__color-swatch" [style.background]="form.get('color')?.value || '#E2E2E2'">
          <input
            class="add-tags__color-picker"
            type="color"
            [value]="toHex(form.get('color')?.value)"
            [disabled]="!canSubmit"
            (input)="onColorPicked($any($event.target).value)"
            [attr.aria-label]="'Labels.label_color' | translate">
        </label>
        <ui-form-field
          class="add-tags__color-text"
          type="text"
          formControlName="color"
          [placeholder]="'Labels.hex_placeholder' | translate">
        </ui-form-field>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(!isUpdate ? 'common.create' : 'common.update') | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
